import { render, staticRenderFns } from "./ChipExchangeClosed.vue?vue&type=template&id=1267e52a"
import script from "./ChipExchangeClosed.vue?vue&type=script&lang=js"
export * from "./ChipExchangeClosed.vue?vue&type=script&lang=js"
import style0 from "./ChipExchangeClosed.vue?vue&type=style&index=0&id=1267e52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports